import type { USER_TYPE } from "../object-actions/types/types";

/** Matches RoleBasedMenu priority for org-wide role display. */
export function pickPrimaryMembershipRole(roles: USER_TYPE[] | undefined | null): USER_TYPE | null {
    if (!roles?.length) return null;
    if (roles.includes("admin") || roles.includes("agent")) return roles.includes("admin") ? "admin" : "agent";
    if (roles.includes("coach")) return "coach";
    if (roles.includes("parent")) return "parent";
    if (roles.includes("athlete")) return "athlete";
    if (roles.includes("payer")) return "payer";
    return roles[0];
}
